import React from "react";
import { Link } from "react-router-dom";
import { InfoOutlined } from "@mui/icons-material";
import { Button, Paper } from "@mui/material";
import BaseSelect from "components/Shared/Base/BaseSelect";
import { BaseTextField } from "components/FormBuilder/fields/BaseTextField";
import { ActionCard } from "components/Shared/UI/ActionCard/ActionCard";
import { useAuth } from "hooks";
import { ConfirmDeleteMyAccount } from "./ConfirmDeleteMyAccount";

const deletionReasons = [
  "The CRM doesn't meet our business needs",
  "We found a better CRM solution",
  "Too many technical issues with the platform",
  "The system is too difficult to use",
  "Our business is closing",
  "Data privacy concerns",
  "Other reason",
];

export const DeleteAccountScreen = () => {
  const [confirmText, setConfirmText] = React.useState("");
  const [reason, setReason] = React.useState("");

  const _softDeleteRef = React.useRef(null);

  const { viewEntity } = useAuth();

  return (
    <div className="bg-gray-50 py-10">
      <div className="container mx-auto h-screen max-w-4xl">
        <div className="mb-10">
          <img
            src={viewEntity?.entity?.logo?.url}
            alt="Logo"
            className="h-[120px] w-[120px] object-contain"
          />
        </div>

        <Paper variant="outlined">
          <ActionCard>
            <ActionCard.Content>
              <div className="grid gap-6 ">
                <div>
                  <div className="mb-2 text-2xl font-medium">
                    Delete Account{" "}
                  </div>

                  <div>
                    Once you delete your account, there is no going back. Please
                    be certain.
                  </div>
                </div>

                <div className="rounded border border-orange-300 bg-orange-50 px-4 py-2 ">
                  <div>
                    <span>
                      <InfoOutlined fontSize="small" color="warning" />{" "}
                    </span>
                    <span>Before you proceed, please note: </span>
                  </div>

                  <ul className="ml-5 grid gap-1">
                    <li className="list-inside list-disc">
                      All your data, history will be deleted.
                    </li>
                    <li className="list-inside list-disc">
                      Team members connected to your account will lose their
                      access
                    </li>
                    <li className="list-inside list-disc">
                      This action cannot be undone or recovered.
                    </li>
                  </ul>
                </div>

                <div>
                  <div className="mb-2 text-sm">
                    Please tell us why you're discontinuing our CRM service
                    (optional)
                  </div>

                  <BaseSelect
                    fullWidth
                    label="Select Reason"
                    options={deletionReasons}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  />
                </div>

                <div>
                  <div className="mb-2 text-sm">
                    Type <span className="font-medium">Confirm</span> to proceed
                    deleting account.
                  </div>

                  <BaseTextField
                    value={confirmText}
                    onChange={(e) => setConfirmText(e.target.value)}
                  />
                </div>
              </div>
            </ActionCard.Content>

            <ActionCard.Actions alignLeft>
              <Button
                variant="contained"
                color="error"
                disableElevation
                onClick={() =>
                  _softDeleteRef.current.handleToggleConfirmation()
                }
                disabled={confirmText.toLowerCase() !== "confirm"}
              >
                Delete Account
              </Button>

              <Link to="/app/me">
                <Button>Cancel</Button>
              </Link>
            </ActionCard.Actions>
          </ActionCard>
        </Paper>

        <ConfirmDeleteMyAccount ref={_softDeleteRef} />
      </div>
    </div>
  );
};
